import*as e from"@swc/helpers";import*as r from"react";import{DynamicDeliveryIndicator as t}from"@grandvisionhq/shipping";const o=o=>r.createElement(t,e.extends({},o,{view:"text"}));export{o as D};
//# sourceMappingURL=DynamicDeliveryIndicatorContainer-622053ce.js.map
